import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import type { Provider } from '../../types';

interface UserMenuProps {
  provider: Provider | undefined;
}

export function UserMenu({ provider }: UserMenuProps) {
  const { signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const avatarHtml = provider?.headshotUrl
    ? <img src={provider.headshotUrl} alt="" className="user-menu__avatar" />
    : (
      <div className="user-menu__avatar-placeholder">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
        </svg>
      </div>
    );

  return (
    <div className="user-menu" id="userMenu" ref={ref}>
      <button
        className="user-menu__trigger"
        id="userMenuBtn"
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
      >
        <span id="providerName">{provider?.name || ''}</span> &#9662;
      </button>
      <div className={`user-menu__dropdown${open ? ' show' : ''}`} id="userMenuDropdown">
        <div className="user-menu__header" id="userMenuHeader">
          {avatarHtml}
          <div className="user-menu__name">{provider?.name || ''}</div>
          <div className="user-menu__email">{provider?.email || ''}</div>
        </div>
        <div className="user-menu__links">
          <Link to="/settings#provider" className="user-menu__item" onClick={() => setOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: '-2px', marginRight: '0.35rem' }}>
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
            </svg>
            Provider Settings
          </Link>
          <Link to="/settings#practice" className="user-menu__item" onClick={() => setOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: '-2px', marginRight: '0.35rem' }}>
              <path d="M3 21h18" /><path d="M5 21V7l8-4v18" /><path d="M19 21V11l-6-4" /><path d="M9 9v.01" /><path d="M9 12v.01" /><path d="M9 15v.01" /><path d="M9 18v.01" />
            </svg>
            Practice Settings
          </Link>
          <hr className="user-menu__divider" />
          <a
            href="#"
            className="user-menu__item user-menu__item--danger"
            id="logoutBtn"
            onClick={async (e) => {
              e.preventDefault();
              await signOut();
            }}
          >
            Sign Out
          </a>
        </div>
      </div>
    </div>
  );
}
